export default {
  activation: {
    comment: {
      label: "Comment",
      placeholder: "If you have any additional information, please enter it here."
    },
    description: "Please provide feedback on the activation. This is important for reporting and for the further development of the system.",
    resolved: "and resolved at {time}",
    result: {
      caught: "Mouse caught",
      empty: "Trap empty",
      maintenance: "Maintenance (will be ignored)",
      title: "Result"
    },
    save: "Save feedback",
    saved: "Feedback saved. Thank you!",
    title: "Trap was activated at {time}"
  },
  alertSelect: {
    alerts: {
      deviceOffline: "Device offline",
      lowBattery: "Low battery",
      mousePresent: "Mouse detected",
      springDisarmed: "Trap triggered"
    }
  },
  alerts: {
    edit: "Manage alerts",
    org: "Organization",
    title: "Alerts"
  },
  areas: {
    "delete": "Delete area",
    edit: "Edit area",
    "new": "Add area",
    properties: {
      location: {
        label: "Location"
      },
      map: {
        description: "Upload a map of the area to be able to visualize your devices according to their actual positions.",
        label: "Floor plan"
      },
      name: {
        label: "Name"
      }
    },
    title: "Areas"
  },
  changelog: {
    date: "Release date: {date}",
    link: "Read the full changelog",
    title: "Version {version}"
  },
  charts: {
    "temperature-humidity": {
      name: "Temp/Humidity"
    }
  },
  claimSelect: {
    claims: {
      create: "Create",
      "delete": "Delete",
      maintenance: "Maintenance",
      preview: "Preview",
      read: "Read",
      write: "Write"
    },
    copyFromRole: "Copy claims from another role",
    group: {
      devices: "Devices",
      feature: "Feature",
      firmwares: "Firmwares",
      locations: "Locations",
      orgs: "Organizations",
      roles: "Roles",
      system: "System",
      tokens: "Tokens",
      users: "Users"
    },
    selectRoleToCopy: "Select a role to copy claims from"
  },
  colorScheme: {
    auto: "System",
    dark: "Dark",
    light: "Light",
    title: "Color scheme"
  },
  common: {
    any: "Any",
    back: "Back",
    cancel: "Cancel",
    confirm: "Confirm",
    copy: "Copy",
    create: "Create",
    ctrl: "Ctrl",
    "delete": "Delete",
    deleteConfirmMessage: "Are you sure you want to delete \"{name}\"?",
    level: "Level",
    loading: "Loading...",
    loadingComponent: "Loading component...",
    logout: "Logout",
    moreResults: "There are more results. Use the search field to narrow down the results.",
    no: "No",
    noResults: "No items found matching the search criteria",
    off: "Off",
    ok: "OK",
    on: "On",
    reconnecting: "Reconnecting...",
    reloadPage: "Reload page",
    save: "Save",
    search: "Search",
    select: "Select",
    state: "State",
    submit: "Submit",
    unsavedChanges: "You have unsaved changes. Are you sure you want to leave?",
    yes: "Yes"
  },
  device: {
    create: {
      alreadyRegistered: "This device is already registered in another location! Are you sure you want to register it here?",
      deviceId: "Device ID:",
      instructions: "To register the device, please enter a description. You can add more details in the next step.",
      noPermission: "You do not have permission to register a device",
      register: "Register device",
      title: "Registering device",
      type: "Device type:"
    },
    details: {
      title: "Device details"
    },
    edit: {
      confirmUnregister: {
        confirm: "Unregister",
        message: "Are you sure you want to delete the device from the current location?"
      },
      moreActions: "More actions",
      replace: "Replace device",
      title: "Edit device",
      unregister: "Unregister device"
    },
    history: {
      action: {
        added: "created",
        changed: "updated",
        registered: "registered in {location}",
        removed: "deleted",
        unregistered: "unregistered from {location}"
      },
      dateFilter: "Date range",
      device: "Device",
      deviceFilter: {
        all: "All devices",
        title: "Device"
      },
      filterNoMatch: "No devices match the selected filters",
      notFound: "Device with id {id} not found",
      title: "Device history",
      tooManyItems: "Incomplete results - only {count} items are shown. There are too many items to display. Please narrow down the search criteria and make sure the device is not sending too many events.",
      tooManyItemsDevices: "The following devices are sending too many events. The history is displayed truncated:",
      typeFilter: {
        all: "All types",
        events: "Device events",
        history: "User changes",
        title: "Log Type"
      }
    },
    lookingUp: "Looking up...",
    mustSelectLocation: "Please select a location before scanning a device to register it.",
    notFound: "Sorry, we could not find a device with id {id}",
    properties: {
      battery: {
        label: "Battery"
      },
      description: {
        description: "Where is the device located?",
        label: "Description",
        placeholder: "E.g. North wall, 2nd floor, left corner"
      },
      id: {
        label: "Device ID"
      },
      location: {
        label: "Location"
      },
      map: {
        clearPosition: "Clear position",
        description: "Where is the device located?",
        doneSelectingPosition: "Done selecting position",
        label: "Map",
        selectPosition: "Select position"
      },
      photo: {
        description: "Take a photo of the device if it's in an unusual location",
        drop: "Drop a file here",
        label: "Device Photo",
        pasteDropFile: "Or Paste/Drop a file",
        previewLabel: "Preview of the selected image",
        remove: "Remove file",
        replaceFile: "Replace file",
        selectFile: "Choose file",
        takePhoto: "Take a photo"
      },
      registeredOn: {
        label: "Registered on"
      },
      sequenceNumber: {
        label: "Sequence number"
      },
      state: {
        label: "State"
      },
      type: {
        label: "Type"
      }
    },
    replace: {
      confirmation: "Are you sure you want to replace the device?",
      instructions: "Scan the QR code on the new device.",
      newDevice: "New device ID",
      notFound: "Device with id {id} not found",
      oldDevice: "Old device ID",
      processing: "Replacing device...",
      replace: "Replace device",
      rescan: "Rescan",
      sameDevice: "The new device cannot be the same as the old device",
      title: "Replace device",
      wrongType: "The new device is not of the same type as the old device"
    },
    scanToRegister: "The device is currently not registerd in {location}. Please scan the device's QR-code to register it"
  },
  entities: {
    device: "Device",
    gateway: "Gateway",
    trap: "Trap"
  },
  errors: {
    conflict: "Data has been changed by another user. Please refresh the page and try again.",
    nameTaken: "The name is already taken",
    network: "Network error",
    networkMessage: "Could not fetch {url}",
    title: "An error occurred",
    tokenExpired: "The reset token has expired.\nPlease request a new one.",
    validation: "Validation failed"
  },
  forgotPassword: {
    done: "An email has been sent to {email} with a link to reset your password.",
    email: {
      description: "Enter the email address you use to log in. We will send you a link to reset your password.",
      label: "Email address"
    },
    title: "Forgot password"
  },
  header: {
    global: "Global",
    manageLocation: "Manage location {location}",
    selectLocation: "Please select a location"
  },
  history: {
    action: "Action",
    changes: "Changes",
    time: "Time",
    user: "User"
  },
  inventory: {
    filters: {
      all: "All",
      gateway: "Gateways",
      locations: "Locations",
      trap: "Traps"
    },
    link: "Inventory",
    settings: {
      includeLocationless: "Include devices without a location",
      title: "Settings"
    }
  },
  itemFilters: {
    createdOn: "Created on",
    locationId: "Location",
    orgId: "Organization",
    title: "Add filters"
  },
  loadingModule: {
    title: "Loading module..."
  },
  locationMap: {
    addMap: "Upload a map",
    editAreas: "Edit areas",
    noMap: "There is no map for this location yet.",
    showConnections: "Show connections"
  },
  locationSelect: {
    nothingFound: "No locations available"
  },
  locations: {
    "delete": "Delete location",
    edit: "Edit location",
    empty: "No locations",
    link: "Manage Locations",
    locations: "Locations",
    "new": "Add location",
    noResults: "No locations found matching the search criteria",
    pleaseCreate: "Please add a location to place your assets",
    properties: {
      city: {
        label: "City"
      },
      name: {
        label: "Name"
      },
      orgs: {
        description: "You can assign the location to one or more organizations.",
        label: "Organizations"
      },
      street: {
        label: "Street"
      },
      zip: {
        label: "Zip"
      }
    },
    search: "Search for locations",
    title: "Manage Locations"
  },
  log: {
    link: "Logbook",
    title: "Logbook"
  },
  login: {
    forgotPassword: "Forgot password?",
    login: "Login",
    loginFailed: "Login failed",
    noAccount: "Don't have an account?",
    noAccountText: "Please contact your administrator to create an account for you.",
    password: "Your password",
    title: "Login",
    user: "Your user name",
    wrongEmailOrPassword: "Wrong email or password"
  },
  maintenance: {
    alert: {
      disable: "Disable",
      title: "Maintenance mode is enabled"
    },
    disable: "Disable maintenance mode",
    disableDialog: {
      message: "Disabling maintenance mode..."
    },
    enable: "Enable maintenance mode",
    enableDialog: {
      description: "During maintenance mode, no alerts will be sent. Use it when you are moving, replacing or otherwise working on devices.",
      duration: {
        description: "Duration in minutes. Maintenance mode will be disabled automatically after this time.",
        label: "Duration"
      },
      enable: "Enable now"
    },
    title: "Maintenance mode"
  },
  map: {
    critical: "{count}x Critical",
    link: "Map",
    noIssues: "Currently there are no issues",
    offline: "{count}x Offline",
    ok: "{count}x OK",
    warning: "{count}x Warning"
  },
  notFound: {
    backToHome: "Go back to Start",
    message: "Sorry, we couldn't find the page you were looking for.",
    title: "Page not found"
  },
  orgSelect: {
    nothingFound: "No organizations available"
  },
  orgType: {
    global: "Global",
    location: "Location",
    tenant: "Tenant"
  },
  orgUsers: {
    add: {
      description: "Search by name or email address",
      newUser: "This user is not registered yet. Please enter their information below.",
      save: "Add user",
      title: "Add a user to {org}"
    },
    addUser: "Add user",
    edit: {
      removeUser: "Remove user",
      save: "Update user",
      title: "Edit user roles in {org}",
      user: "User"
    },
    locationHint: "You can assign users to this location. Note that users of the above organization will already have access to this location and don't need to be added here.",
    title: "Manage user roles"
  },
  orgs: {
    "delete": "Delete organization",
    edit: "Edit organization",
    empty: "No organizations",
    link: "Manage Organizations",
    "new": "Add organization",
    noResults: "No organizations found matching the search criteria",
    pleaseCreate: "Please add an organization",
    properties: {
      name: {
        label: "Name"
      },
      type: {
        label: "Organisation Type"
      }
    },
    title: "Manage Organizations"
  },
  overview: {
    catchStats: {
      catches: "Catches in the period: {count}"
    },
    current: "Current",
    filter: {
      empty: "No organizations or locations to display",
      emptyWithQuery: "No organizations or locations match the search criteria",
      excludeAll: "Exclude all",
      includeAll: "Include all",
      includeOrExclude: "Include or exclude organizations and locations",
      moreResults: "There are more results. Please narrow down the search criteria.",
      showAll: "All locations",
      showCount: "{count, plural, one {# location} other {# locations}}"
    },
    link: "Home",
    topStats: {
      "catch": "Catches",
      interpolation: "Interpolation",
      traps: "Traps",
      triggered: "Triggered"
    },
    trend: "Trend"
  },
  profile: {
    changelog: "Changelog",
    link: "Profile",
    title: "Profile"
  },
  resetPassword: {
    done: {
      "activate-account": "Your account has been activated. Happy trapping!",
      "reset-password": "Your password has been reset."
    },
    invalidToken: "Invalid token",
    missingToken: "No token provided. Please use the link in the email to reset your password.",
    newPassword: "New password",
    resetFailed: "Reset failed",
    title: {
      "activate-account": "Activate your account",
      "reset-password": "Reset your password"
    }
  },
  roleSelect: {
    noRoles: "No roles available to select"
  },
  roles: {
    "delete": "Delete role",
    edit: "Edit role",
    "new": "Add role",
    properties: {
      alerts: {
        description: "Select the alerts that should be sent to users with each role.",
        label: "Alerts"
      },
      claims: {
        description: "Claims are used to control access to resources. Select the claims that apply to this role.",
        label: "Claims",
        noClaims: "There are no claims available for this role"
      },
      name: {
        label: "Name"
      },
      org: {
        label: "Organization"
      },
      orgId: {
        label: "Organization"
      }
    },
    title: "Roles",
    type: {
      global: "Default roles",
      local: "Organization roles",
      org: "{org} roles"
    }
  },
  scanner: {
    button: "Scan QR Code",
    permissionDenied: "Access to the camera has been denied",
    permissionRequired: "Please allow access to the camera",
    unknownCode: "Unknown code"
  },
  sensors: {
    activationFeedbackRequired: {
      issue: {
        title: "Feedback required"
      }
    },
    battery: {
      issue: {
        critical: "Charge now",
        title: "Low battery",
        warning: "Charge soon"
      },
      name: "Battery"
    },
    batteryLevel: {
      name: "Battery level"
    },
    calibration: {
      name: "Calibration"
    },
    connectivity: {
      issue: {
        offline: "Check connection",
        title: "Offline"
      },
      name: "Connectivity",
      state: {
        offline: "Offline",
        online: "Online"
      }
    },
    delay: {
      name: "Delay"
    },
    error: {
      name: "Error",
      state: {
        "0": "No error",
        "1": "Bad connection",
        "10": "Settings changed successfully",
        "11": "Unknown error",
        "2": "Resend too quick",
        "3": "Out of bounds sensor values",
        "4": "Reset",
        "5": "Received a downlink successfully",
        "6": "Downlink deprecated",
        "7": "Downlink unknown",
        "8": "Downlink invalid",
        "9": "Executing task failed"
      }
    },
    firmwareVersion: {
      name: "Firmware version"
    },
    hardwareVersion: {
      name: "Hardware version"
    },
    humidity: {
      name: "Humidity"
    },
    lastSeen: {
      issue: {
        offline: "Check connection",
        title: "Offline"
      },
      name: "Last seen"
    },
    mouse: {
      issue: {
        critical: "Empty now",
        title: "Mouse detected"
      },
      name: "Mouse",
      state: {
        absent: "No",
        present: "Detected"
      }
    },
    retries: {
      name: "Retries"
    },
    rssi: {
      name: "RSSI"
    },
    sensor: {
      name: "Sensor"
    },
    snr: {
      name: "SNR"
    },
    spring: {
      issue: {
        title: "Triggered",
        warning: "Needs to be set"
      },
      name: "Spring",
      state: {
        armed: "Set",
        disarmed: "Triggered"
      }
    },
    stability: {
      issue: {
        title: "Unstable",
        unstable: "Unstable"
      },
      name: "Stability",
      state: {
        stable: "Stable",
        unstable: "Unstable"
      }
    },
    temperature: {
      name: "Temperature"
    },
    threshold: {
      name: "Threshold"
    },
    uptime: {
      name: "Uptime"
    },
    wakeup: {
      name: "Wakeup"
    }
  },
  settings: {
    language: "Language",
    link: "Settings",
    title: "Settings"
  },
  state: {
    critical: "Critical",
    offline: "Offline",
    ok: "OK",
    warning: "Warning"
  },
  stats: {
    link: "Stats"
  },
  svgMap: {
    zoomHint: "Use Ctrl + Mouse Wheel to zoom in and out"
  },
  table: {
    calendarWeek: "Calendar week",
    clearFilters: "Clear filters",
    deselectAll: "Deselect all",
    exportCopy: "To clipboard",
    exportDownload: "Download",
    exportTitle: "Export",
    hideAllColumns: "Hide all",
    lastMonths: "{n, plural, one {Last month} other {Last # months}}",
    lastSevenDays: "Last 7 days",
    lastThirtyDays: "Last 30 days",
    loading: "Loading...",
    noResults: "No results",
    rangeMax: "Max",
    rangeMin: "Min",
    reset: "Reset",
    resetAll: "Reset table settings",
    selectColumns: "Select columns",
    showAllColumns: "Show all",
    thisMonth: "This month",
    thisWeek: "This week",
    thisYear: "This year",
    today: "Today"
  },
  title: "Mouse Over",
  userPicker: {
    invite: "Send an email invitation",
    notFound: "{user} is not registered"
  },
  users: {
    "delete": "Delete user",
    edit: "Edit user",
    empty: "No users",
    link: "Manage Users",
    "new": "Add user",
    newUserHint: "When users are created, they will receive an email with a link to set their password.",
    noResults: "No users found matching the search criteria",
    pleaseCreate: "Please add a user",
    properties: {
      email: {
        alert: {
          enabled: "Send alerts to this email address",
          schedules: {
            description: "Select the time(s) of the day when you want to receive alerts. If you don't select any times, you will receive alerts immediately.",
            label: "Alert schedules"
          }
        },
        change: "Change email",
        changeSuccess: "Email address changed. Please check your email for a confirmation link.",
        changeTeaser: "You can change the email address here. You will have to confirm the new email address by clicking a link in an email that will be sent to the new address.",
        description: "The email address is used to log in and to send notifications",
        label: "Email address",
        newEmail: "New email address"
      },
      firstName: {
        label: "First Name"
      },
      language: {
        description: "The language for the user interface and notifications",
        label: "Language"
      },
      lastName: {
        label: "Last Name"
      },
      orgRoles: {
        addToOrg: "Add to organization or location",
        description: "You can assign the user to one or more organizations and locations and assign a role in each.",
        label: "Organization Roles",
        noMatch: "No matches found",
        noRoles: "This organization has no roles",
        selectOrg: "Select an organization or location to add the user to",
        selectRolesInOrg: "Select roles in {org}"
      },
      password: {
        change: "Change password",
        changeSuccess: "Password changed",
        changeTeaser: "You can change the password here.",
        description: "Please choose a strong password",
        label: "Password",
        newPassword: "New password",
        oldPassword: "Old password"
      },
      timezone: {
        browser: "Your browser's timezone",
        description: "The timezone for the user interface and notifications",
        label: "Timezone",
        others: "Other timezones"
      }
    },
    search: "Search",
    section: {
      email: "Email settings",
      password: "Change Password",
      personalInformation: "Personal Information"
    },
    title: "Manage Users"
  },
  validation: {
    atLeastOneOrg: "Assign at least one role in at least one organization",
    different: "Please enter a different password",
    email: "Please enter a valid email address",
    password: "Password must be at least {passwordLength} characters long",
    required: "Please enter a value"
  },
  verifyEmail: {
    done: "Your email address has been verified.",
    message: "That should only take a moment...",
    title: "Verifying your email address"
  }
} as const;
